import { Stack, TextField } from '@mui/material'
import useStyles from './styles'
import React, { useCallback, useState } from 'react'
import { DrawingSettingItem, Point, SettingValues } from '../../drawingTools/drawing.interface'
import Chart from '../../chart'
import { Time } from 'lightweight-charts'

export type CoordinateFieldProps = {
    value: Point,
    onChange: (value: Point) => void,
    setting: DrawingSettingItem<any, SettingValues>,
    chart: Chart
}

const CoordinateField: React.FC<CoordinateFieldProps> = ({ value, onChange, setting, chart }) => {
    const { classes } = useStyles()
    const [xValue, setXValue] = useState<string>(Math.round(Number(chart.chartApi.timeScale().timeToCoordinate(value.x))).toString())

    const getTimeValue = useCallback((event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        return chart.chartApi.timeScale().coordinateToTime(Math.round(Number(event.target.value))) ?? 0 as Time
    }, [value])

    return <Stack gap={2} direction={'row'}>
        {setting.fieldOptions?.showY !== false && (
            <TextField
                className={classes.priceInput}
                size="small"
                value={value.y.toFixed(2)}
                type="number"
                onChange={(event) => {
                    onChange({ ...value, y: Number(event.target.value) })
                }}
            />
        )}
        {setting.fieldOptions && setting.fieldOptions.showX &&
            <TextField className={classes.priceInput} size="small" value={xValue} type="number"
                       onChange={(event) => {
                           setXValue(event.target.value)
                           onChange({ ...value, x: getTimeValue(event) })
                       }} />}
    </Stack>
}

export default CoordinateField

